import * as crowdAdd2 from '../services/crowdAdd';

export default {
  namespace: 'crowdAdd2',

  state: {
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
    memberDetail: {},
  },

  effects: {
    //获取该会员详情
    *getMemberDetail({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowdAdd2.getMemberDetail, values);
      console.log(response, 'response');
      yield put({
        type: 'save',
        payload: {
          memberDetail: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getUserGroupList({ payload: { values } }, { call, put }) {
      const response = yield call(crowdAdd2.getUserGroupList, {
        ...values,
        status: 1,
      });
      yield put({
        type: 'save',
        payload: {
          userGroupList: response?.data,
        },
      });
    },

    //获取活动相关信息
    *getActivityInfo({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowdAdd2.getActivityInfo, values);
      yield put({
        type: 'save',
        payload: {
          activityInfo: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 清除数据
    *clearActivityInfo({}, { put }) {
      yield put({
        type: 'save',
        payload: {
          activityInfo: [],
        },
      });
    },

    //新增活动人群
    *addActivityGroup({ payload: { values }, callback }, { call }) {
      const response = yield call(crowdAdd2.addActivityGroup, values);
      // yield put({
      //   type: 'save',
      //   payload: {
      //     ActivityInfo: response?.data,
      //   },
      // });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //更新活动人群
    *updateActivityGroup({ payload: { values }, callback }, { call }) {
      const response = yield call(crowdAdd2.updateActivityGroup, values);
      // yield put({
      //   type: 'save',
      //   payload: {
      //     ActivityInfo: response?.data,
      //   },
      // });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // 获取微信模板
    *getWechatTemplateList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowdAdd2.getWechatTemplateList, values);
      yield put({
        type: 'save',
        payload: {
          wechatTemplateList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 获取短信模板消息
    *getSmsTemplateList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(crowdAdd2.getSmsTemplateList, values);
      yield put({
        type: 'save',
        payload: {
          smsTemplateList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 获取周期类型将月和天放进去
    *getCycleTypeList({ payload: { values }, callback }, { all, call, put }) {
      const [cycleTypeList, monthDayList, weekDayList] = yield all([
        call(crowdAdd2.getCycleTypeList, values),
        call(crowdAdd2.getMonthDayList, values),
        call(crowdAdd2.getWeekDayList, values),
      ]);

      yield put({
        type: 'save',
        payload: {
          cycleData: {
            cycleTypeList: cycleTypeList?.data,
            monthDayList: monthDayList?.data,
            weekDayList: weekDayList?.data,
          },
        },
      });
      if (callback && typeof callback === 'function') {
        return callback();
      }
    },
    *postManualOperation({ payload: { values }, callback }, { call }) {
      const response = yield call(crowdAdd2.postManualOperation, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
    },
    *getCouponDetail({ payload: { values }, callback }, { call }) {
      const response = yield call(crowdAdd2.getCouponDetail, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
    },
    *getAdjustCouponList({ payload: { values }, callback }, { call }) {
      const response = yield call(crowdAdd2.getAdjustCouponList, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname === '/marketing/crowd/registered_unpaid' ||
          props.pathname === '/marketing/crowd/key_recall' ||
          props.pathname === '/marketing/crowd/custom_crowd' ||
          props.pathname === '/marketing/crowd/assign_telephone'
        ) {
          dispatch({
            type: 'clearActivityInfo',
            payload: {
              values: {},
            },
          });
        }
      });
    },
  },
};
